// extracted by mini-css-extract-plugin
module.exports = {"SupplierServices__row":"SupplierServices_SupplierServices__row___ZfH3","SupplierServices__phoneNumber":"SupplierServices_SupplierServices__phoneNumber__kWQHL"};